var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgITechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24674",
    "data-name": "Rectangle 24674",
    width: 17.583,
    height: 19.852,
    fill: "#f49423"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50147",
    "data-name": "Group 50147",
    transform: "translate(-245 -1803)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(245 1803)",
    fill: "#f49423",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50146",
    "data-name": "Group 50146",
    transform: "translate(252.705 1810.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50145",
    "data-name": "Group 50145",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78415",
    "data-name": "Path 78415",
    d: "M7.651,6.8V5.334l.619.044-.4,1.482.053.035c.233-.347.483-.685.693-1.046a.538.538,0,0,1,.632-.3,1.662,1.662,0,0,1,1.132.642c.541.739,1.077,1.483,1.612,2.22-.528.839-1.03,1.663-1.56,2.468-.283.429-.666.42-1.22-.015l-.073.524h8.443v.644l-.314.056V19.4H9.826V12.074H9.072a13.93,13.93,0,0,0-.231,3.717c-.016.977-.006,1.955-.038,2.932a1.056,1.056,0,0,1-1.23,1.12.763.763,0,0,1-.75-.852,1.431,1.431,0,0,0-.582-1.417c-.87-.792-1.69-1.638-2.53-2.463A1.026,1.026,0,0,1,3.556,13.6c.32-.478.618-.975.974-1.425a2.885,2.885,0,0,0,.546-1.5c.143-1.1.3-2.188.455-3.282.01-.07.026-.139.032-.209.043-.457-.047-.55-.489-.5-.5.06-1,.115-1.5.192a.328.328,0,0,1-.4-.194c-.418-.8-.853-1.6-1.26-2.4a.7.7,0,0,1-.071-.533c.142-.268.022-.431-.1-.63C1.229,2.31.725,1.489.218.669A1.721,1.721,0,0,1,.008.3.765.765,0,0,1,.046,0c.1.036.238.043.283.112C.671.633.994,1.167,1.322,1.7c.285.46.561.925.86,1.375a.473.473,0,0,0,.314.166.757.757,0,0,1,.686.461c.213.469.459.924.689,1.385A.353.353,0,0,0,4.29,5.3c.712-.083,1.429-.13,2.144-.186.5-.039.623.048.778.512q.2.591.394,1.183L7.651,6.8M5.63,14.066l1.264,1.371c0-.913,0-1.728,0-2.542a.977.977,0,0,0-.106-.3c-.1.06-.229.1-.29.183-.31.44-.6.893-.863,1.284m4.052-6.54L9.373,9.754a9.543,9.543,0,0,0,.811-1.267.219.219,0,0,0,0-.185c-.142-.236-.3-.464-.5-.775M7.7,8.289c.153-.215.3-.333.3-.453,0-.1-.181-.287-.263-.278a.429.429,0,0,0-.306.272c-.017.107.131.24.267.458m.318.469c-.2-.136-.327-.279-.45-.279-.1,0-.283.2-.265.274a.47.47,0,0,0,.3.3c.093.017.22-.147.415-.293",
    transform: "translate(0)",
    fill: "#f49423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78416",
    "data-name": "Path 78416",
    d: "M96.434,30.188a1.488,1.488,0,0,1-2.976-.005,1.488,1.488,0,1,1,2.976.005",
    transform: "translate(-86.831 -26.658)",
    fill: "#f49423"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgITechIcon);
export default __webpack_public_path__ + "static/media/i-tech-icon.8f80b6ab10fae96f22ba49e91eee982c.svg";
export { ForwardRef as ReactComponent };